import './plugins'

export default {}
